import './plugins'

export default {}
